export default __webpack_public_path__ + "static/media/nafsa.e0920ddf.png";